import { notification } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { SUBSCRIPTION_MESSAGE_CLASS_NAME } from 'util/config/constant';
import { getMachineType } from 'util/machine-type';
import { MAPPING_ROUTE_BY_MESSAGE_TYPE } from './util/constant';
import { getDescription } from './util/description';
import { getIcon } from './util/icon';

export const useNotification = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const onClickNotification = useCallback(
    (newMessageId, messageType) => {
      // Redirect to new route based on the message type
      // If the new page and current page are same pathname => reload it
      const currentPathname = history.location.pathname;
      const newPathname = MAPPING_ROUTE_BY_MESSAGE_TYPE[messageType];

      if (currentPathname === newPathname) {
        window.location.reload();
        return;
      }

      history.push(newPathname);
      notification.close(newMessageId);
    },
    [history]
  );

  const openNotification = useCallback(
    (newMessageId, { type: messageType, data }) => {
      const Icon = getIcon(messageType, data);
      const bodyMessageEnum = data.message;

      notification.info({
        message: `${getMachineType(data?.machine?.materialNumber)} / ${
          data?.machine?.alias
        }`,
        description: getDescription(messageType, bodyMessageEnum, t),
        icon: Icon,
        top: 70,
        duration: 5,
        onClick: () => onClickNotification(newMessageId, messageType),
        key: newMessageId,
        className: SUBSCRIPTION_MESSAGE_CLASS_NAME
      });
    },
    [onClickNotification, t]
  );

  return [openNotification];
};
